/* ==========================================================================
   DAVOREL — theme behaviour

   Everything here enhances markup that already works without it: the product
   form posts natively, sort and filters are GET forms, the cart page is a real
   form, the swatch request submits as a normal contact form. If this file fails
   to load, the store still sells.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cfg = window.davorel || { routes: {}, popup: {} };

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function announce(msg) {
    var r = document.getElementById('a11y-status');
    if (!r) return;
    r.textContent = '';
    setTimeout(function () { r.textContent = msg; }, 60);
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || 'R {{amount}}';
    var value = (cents / 100);
    var withDecimals = value.toFixed(2);
    function sep(n, thousands, decimal) {
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return sep(value.toFixed(0), ',', '.');
        case 'amount_with_comma_separator': return sep(withDecimals, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(value.toFixed(0), '.', ',');
        case 'amount_with_space_separator': return sep(withDecimals, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return sep(value.toFixed(0), ' ', ',');
        case 'amount_with_apostrophe_separator': return sep(withDecimals, "'", '.');
        default: return sep(withDecimals, ',', '.');
      }
    });
  }

  /* ----------------------------------------------------------------------
     Header: floats over the opening photograph until the visitor scrolls
     ---------------------------------------------------------------------- */
  var header = $('[data-header]');
  if (header) {
    var stuckAt = document.body.classList.contains('has-overlay') ? 60 : 8;
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > stuckAt); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ----------------------------------------------------------------------
     Drawers: menu, cart, filters. Focus trapped, restored on close, Escape closes.
     ---------------------------------------------------------------------- */
  var Drawer = {
    active: null,
    lastFocus: null,
    open: function (id) {
      var el = document.getElementById(id);
      if (!el || Drawer.active === el) return;
      if (Drawer.active) {
        var keep = Drawer.lastFocus;
        Drawer.close(true);
        Drawer.lastFocus = keep;
      } else {
        Drawer.lastFocus = document.activeElement;
      }
      closeNav();
      el.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      Drawer.active = el;
      $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      void el.offsetWidth; // commit the closed state so the transition runs, and so focus() below lands
      el.classList.add('is-open');
      var panel = $('.drawer__panel', el);
      var first = $(FOCUSABLE, panel);
      if (first) first.focus({ preventScroll: true });
    },
    close: function (skipRestore) {
      var el = Drawer.active;
      if (!el) return;
      el.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      $$('[data-drawer-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var done = function () { if (!el.classList.contains('is-open')) el.hidden = true; };
      if (reduceMotion.matches) done(); else setTimeout(done, 340);
      if (!skipRestore && Drawer.lastFocus && Drawer.lastFocus.focus) Drawer.lastFocus.focus();
      Drawer.active = null;
    },
    trap: function (e) {
      var scope = Drawer.active ? $('.drawer__panel', Drawer.active) : (Popup.open ? $('.popup__panel') : (Search.open ? $('.search-modal__panel') : null));
      if (!scope || e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, scope).filter(function (n) { return n.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); Drawer.open(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Drawer.close(); }
  });

  /* ----------------------------------------------------------------------
     Desktop navigation drop-downs: hover with intent, click/Enter, Escape.
     ---------------------------------------------------------------------- */
  var navItems = $$('[data-nav-item]');
  var navTimer = null;
  function closeNav(except) {
    navItems.forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var b = $('[data-nav-toggle]', li);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  function openNav(li) {
    closeNav(li);
    li.classList.add('is-open');
    var b = $('[data-nav-toggle]', li);
    if (b) b.setAttribute('aria-expanded', 'true');
  }
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  navItems.forEach(function (li) {
    var btn = $('[data-nav-toggle]', li);
    btn.addEventListener('click', function () {
      if (li.classList.contains('is-open')) closeNav(); else openNav(li);
    });
    li.addEventListener('mouseenter', function () {
      if (!canHover.matches) return;
      clearTimeout(navTimer);
      navTimer = setTimeout(function () { openNav(li); }, 90);
    });
    li.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      clearTimeout(navTimer);
      navTimer = setTimeout(function () { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 160);
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-nav-item]')) closeNav();
  });

  /* ----------------------------------------------------------------------
     Search overlay + predictive search (Section Rendering API)
     ---------------------------------------------------------------------- */
  var Search = {
    el: $('[data-search-modal]'),
    open: false,
    lastFocus: null,
    show: function (seed) {
      if (!Search.el) return;
      Search.lastFocus = document.activeElement;
      Search.el.hidden = false;
      Search.open = true;
      document.documentElement.style.overflow = 'hidden';
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var input = $('[data-predictive-input]', Search.el);
      if (input) {
        if (seed) input.value = seed;
        input.focus();
        if (input.value) predictive(input.value);
      }
    },
    hide: function () {
      if (!Search.el || !Search.open) return;
      Search.el.hidden = true;
      Search.open = false;
      document.documentElement.style.overflow = '';
      $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (Search.lastFocus && Search.lastFocus.focus) Search.lastFocus.focus();
    }
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); Search.show(); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); Search.hide(); }
  });
  var predictiveTimer = null;
  var predictiveCtrl = null;
  function predictive(q) {
    var box = Search.el && $('[data-predictive-results]', Search.el);
    if (!box) return;
    q = q.trim();
    if (q.length < 2) { box.innerHTML = ''; return; }
    if (predictiveCtrl && predictiveCtrl.abort) predictiveCtrl.abort();
    predictiveCtrl = window.AbortController ? new AbortController() : null;
    var url = (cfg.routes.predictive_search || '/search/suggest') + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag&section_id=predictive-search';
    fetch(url, predictiveCtrl ? { signal: predictiveCtrl.signal } : {})
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = $('[data-predictive-content]', doc);
        box.innerHTML = content ? content.outerHTML : '';
      })
      .catch(function () {});
  }
  if (Search.el) {
    var pin = $('[data-predictive-input]', Search.el);
    if (pin) pin.addEventListener('input', function () {
      clearTimeout(predictiveTimer);
      predictiveTimer = setTimeout(function () { predictive(pin.value); }, 220);
    });
  }

  /* ----------------------------------------------------------------------
     Slideshow: crossfade, dots, pause button, pauses on hover/focus,
     never auto-advances under reduced motion.
     ---------------------------------------------------------------------- */
  $$('[data-slideshow]').forEach(function (show) {
    var slides = $$('[data-slide]', show);
    var dots = $$('[data-slide-to]', show);
    if (slides.length < 2) return;
    var idx = 0;
    var interval = parseInt(show.getAttribute('data-interval'), 10) || 7000;
    var auto = show.getAttribute('data-autoplay') === 'true' && !reduceMotion.matches;
    var paused = false;
    var timer = null;
    var pauseBtn = $('[data-slideshow-pause]', show);

    function go(n) {
      slides[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].removeAttribute('aria-current');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].setAttribute('aria-current', 'true');
      // lazy images in hidden slides: make sure the next one is fetched
      var img = $('img[loading="lazy"]', slides[(idx + 1) % slides.length]);
      if (img) img.loading = 'eager';
    }
    function start() { stop(); if (auto && !paused) timer = setInterval(function () { go(idx + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); start(); });
    });
    if (pauseBtn) {
      if (!auto) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', String(paused));
        $('[data-pause-icon]', pauseBtn).hidden = paused;
        $('[data-play-icon]', pauseBtn).hidden = !paused;
        $('.visually-hidden', pauseBtn).textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        if (paused) stop(); else start();
      });
    }
    show.addEventListener('mouseenter', stop);
    show.addEventListener('mouseleave', start);
    show.addEventListener('focusin', stop);
    show.addEventListener('focusout', function (e) { if (!show.contains(e.relatedTarget)) start(); });
    start();
  });

  /* ----------------------------------------------------------------------
     Reveal on scroll
     ---------------------------------------------------------------------- */
  var reveals = $$('.reveal');
  if (reveals.length) {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { io.observe(el); });
      // Safety net: never leave content invisible (e.g. print, odd viewports).
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-visible'); }); }, 4000);
    }
  }

  /* ----------------------------------------------------------------------
     Auto-submitting selects (collection sort)
     ---------------------------------------------------------------------- */
  $$('[data-autosubmit]').forEach(function (sel) {
    sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
  });

  /* ----------------------------------------------------------------------
     Quantity steppers
     ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var down = e.target.closest('[data-qty-down]');
    var up = e.target.closest('[data-qty-up]');
    if (!down && !up) return;
    var input = $('input', (down || up).closest('[data-qty]'));
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, up ? v + 1 : v - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----------------------------------------------------------------------
     Shopify captcha: bind the invisible hCaptcha as soon as a storefront form
     is touched, so a fast autofill-then-submit is not silently swallowed.
     ---------------------------------------------------------------------- */
  document.addEventListener('focusin', function (e) {
    var f = e.target.closest && e.target.closest('form[action*="/contact"]');
    if (f && window.Shopify && Shopify.captcha && Shopify.captcha.protect && !f.hasAttribute('data-captcha-bound')) {
      f.setAttribute('data-captcha-bound', '');
      try { Shopify.captcha.protect(f); } catch (err) {}
    }
  });

  /* ----------------------------------------------------------------------
     Product page
     ---------------------------------------------------------------------- */
  var root = $('[data-product-root]');
  if (root) initProduct(root);

  function initProduct(scope) {
    var variants = [];
    try { variants = JSON.parse($('[data-variant-json]', scope).textContent); } catch (err) { variants = []; }
    var form = $('[data-product-form]', scope);
    var idField = $('[data-variant-id]', scope);
    var submit = $('[data-add-to-cart]', scope);
    var label = $('[data-add-label]', scope);
    var errorBox = $('[data-form-error]', scope);

    /* gallery: a native swipe strip on phones, a mosaic on desktop, either opens full screen */
    var gallery = $('[data-gallery]', scope);
    var list = $('[data-slides]', scope);
    var slides = $$('[data-slide-id]', scope);
    var nowEl = $('[data-gallery-now]', scope);
    var desktop = window.matchMedia('(min-width: 990px)');
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var zoomed = false, zoomFrom = null;
    function isStrip() { return !desktop.matches || zoomed; }
    function mark(i) {
      current = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      if (nowEl) nowEl.textContent = i + 1;
      // pause any playing video that is no longer visible
      $$('video', scope).forEach(function (v) { if (isStrip() && !v.closest('.is-active')) v.pause(); });
    }
    function show(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      mark(i);
      var how = instant || reduceMotion.matches ? 'auto' : 'smooth';
      if (isStrip()) list.scrollTo({ left: list.clientWidth * i, behavior: how });
      else slides[i].scrollIntoView({ block: 'center', behavior: how });
    }
    if (list) {
      var stripTimer = null;
      list.addEventListener('scroll', function () {
        clearTimeout(stripTimer);
        stripTimer = setTimeout(function () { if (isStrip() && list.clientWidth) mark(Math.round(list.scrollLeft / list.clientWidth)); }, 70);
      }, { passive: true });
    }
    function openZoom(i) {
      zoomFrom = document.activeElement;
      zoomed = true;
      gallery.classList.add('is-zoom');
      document.documentElement.style.overflow = 'hidden';
      show(i, true);
      $('[data-zoom-close]', gallery).focus();
    }
    function closeZoom() {
      if (!zoomed) return;
      zoomed = false;
      gallery.classList.remove('is-zoom');
      document.documentElement.style.overflow = '';
      if (zoomFrom && zoomFrom.focus) zoomFrom.focus({ preventScroll: true });
    }
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom]');
        if (z && !zoomed) { openZoom(slides.indexOf(z.closest('[data-slide-id]'))); return; }
        if (e.target.closest('[data-gallery-all]')) { openZoom(7); return; }
        if (e.target.closest('[data-zoom-close]')) closeZoom();
        if (e.target.closest('[data-gallery-prev]')) show(current - 1);
        if (e.target.closest('[data-gallery-next]')) show(current + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (!zoomed) return;
        if (e.key === 'Escape') { e.stopPropagation(); closeZoom(); }
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
        if (e.key === 'Tab') {
          var items = $$('[data-zoom-close], [data-gallery-prev], [data-gallery-next]', gallery);
          var at = items.indexOf(document.activeElement);
          e.preventDefault();
          items[(at + (e.shiftKey ? -1 : 1) + items.length) % items.length].focus();
        }
      }, true);
    }

    /* variant picker */
    function selected() {
      return $$('[data-option-index]', scope).map(function (fs) {
        var c = $('input[data-option-input]:checked', fs);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return variants.find(function (v) { return opts.every(function (val, i) { return v.options[i] === val; }); }) || null;
    }
    function markAvailability() {
      var cur = selected();
      $$('[data-option-index]', scope).forEach(function (fs) {
        var gi = parseInt(fs.getAttribute('data-option-index'), 10) - 1;
        $$('input[data-option-input]', fs).forEach(function (input) {
          var probe = cur.slice(); probe[gi] = input.value;
          var match = variants.find(function (v) { return probe.every(function (val, i) { return val === null || v.options[i] === val; }); });
          var lab = fs.querySelector('label[for="' + input.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function renderVariant() {
      var opts = selected();
      var v = find(opts);
      $$('[data-option-index]', scope).forEach(function (fs) {
        var gi = parseInt(fs.getAttribute('data-option-index'), 10);
        var out = $('[data-option-selected="' + gi + '"]', scope);
        if (out && opts[gi - 1]) out.textContent = opts[gi - 1];
      });
      markAvailability();
      if (!v) {
        idField.value = '';
        submit.disabled = true;
        label.textContent = 'Unavailable';
        return;
      }
      idField.value = v.id;
      submit.disabled = !v.available;
      label.textContent = v.available ? 'Add to cart' : 'Sold out';
      var sticky = $('[data-sticky-add]', scope);
      if (sticky) sticky.disabled = !v.available;

      var sale = v.compare_at_price > v.price;
      var priceEl = $('[data-price]', scope);
      if (priceEl) {
        priceEl.innerHTML = sale
          ? '<span class="price price--sale"><span class="visually-hidden">Sale price</span><span class="price__current price__current--sale tabular">' + formatMoney(v.price) + '</span><span class="visually-hidden">Regular price</span><s class="price__compare tabular">' + formatMoney(v.compare_at_price) + '</s></span>'
          : '<span class="price"><span class="price__current tabular">' + formatMoney(v.price) + '</span></span>';
      }
      var promo = $('[data-promo]', scope);
      if (promo) {
        promo.hidden = !sale;
        if (sale) {
          $('[data-promo-save]', promo).textContent = formatMoney(v.compare_at_price - v.price);
        }
      }
      var sp = $('[data-sticky-price]', scope);
      if (sp) sp.textContent = formatMoney(v.price);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);

      if (v.featured_media_id) {
        var i = slides.findIndex(function (s) { return s.getAttribute('data-slide-id') === String(v.featured_media_id); });
        if (i > -1) show(i);
      }
    }
    $$('input[data-option-input]', scope).forEach(function (input) { input.addEventListener('change', renderVariant); });
    markAvailability();

    /* add to cart: FormData, so app-added line-item properties (Infinite Options'
       inputs carry form="ProductForm") travel with the request. */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorBox) errorBox.hidden = true;
        if (form.checkValidity && !form.checkValidity()) { form.reportValidity(); return; }
        submit.classList.add('is-loading');
        submit.setAttribute('aria-disabled', 'true');
        var body = new FormData(form);
        // Infinite Options renders its inputs in its own app block, outside this form, and does not
        // always give them form="ProductForm". Collect any line-item property field that is not
        // already part of the form so the wood-stain (etc.) choice reaches the cart.
        $$('[name^="properties["]').forEach(function (el) {
          if (el.form === form || el.disabled || !el.name) return;
          if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
          if (el.type === 'file') { if (el.files && el.files[0]) body.append(el.name, el.files[0]); return; }
          if (el.value === '' ) return;
          body.append(el.name, el.value);
        });
        // Required app fields that live outside the form are not covered by form.checkValidity().
        var missing = $$('[name^="properties["][required]').find(function (el) {
          if (el.form === form) return false;
          if (el.type === 'radio') return !$$('[name="' + el.name.replace(/"/g, '\\"') + '"]').some(function (r) { return r.checked; });
          return !el.value;
        });
        if (missing) {
          submit.classList.remove('is-loading');
          submit.removeAttribute('aria-disabled');
          if (missing.reportValidity) missing.reportValidity();
          missing.scrollIntoView({ block: 'center' });
          return;
        }
        fetch(cfg.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Sorry, that could not be added.');
            announce('Added to your cart');
            document.dispatchEvent(new CustomEvent('davorel:cart:added', { detail: res.body }));
            return refreshCart().then(function () { Drawer.open('cart-drawer'); });
          })
          .catch(function (err) {
            if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
            announce(err.message);
          })
          .finally(function () {
            submit.classList.remove('is-loading');
            submit.removeAttribute('aria-disabled');
          });
      });
    }

    /* sticky add-to-cart: shown once the main button has scrolled out of view */
    var bar = $('[data-sticky-atc]', scope);
    if (bar && submit) {
      bar.hidden = false;
      var check = function () {
        var r = submit.getBoundingClientRect();
        var past = r.bottom < 0;
        var footer = $('.site-footer');
        var atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        bar.classList.toggle('is-visible', past && !atFooter);
      };
      window.addEventListener('scroll', check, { passive: true });
      check();
      $('[data-sticky-add]', bar).addEventListener('click', function () {
        // Run the real form so validation (including app options) applies;
        // if anything blocks it, bring the buy box into view.
        submit.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        if (form.requestSubmit) form.requestSubmit(); else submit.click();
      });
    }

    /* Judge.me: move a review widget dropped into the buy box into the Reviews row */
    function adoptReviews() {
      var panel = $('[data-reviews-panel]', scope);
      var item = $('[data-reviews-item]', scope);
      if (!panel || !item || panel.children.length) return;
      var widget = $$('[data-app-block]', scope).find(function (b) { return b.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [id^="judgeme_product_reviews"]'); });
      if (!widget) return;
      panel.appendChild(widget);
      item.hidden = false;
    }
    adoptReviews();
    setTimeout(adoptReviews, 1500);
    // Judge.me badge click opens the Reviews row
    scope.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-prev-badge')) {
        var item = $('[data-reviews-item]', scope);
        if (item && !item.hidden) { e.preventDefault(); item.open = true; item.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }
    });
  }

  /* ----------------------------------------------------------------------
     Recommendations: fetched when the row nears the viewport
     ---------------------------------------------------------------------- */
  var recs = $('[data-recs]');
  if (recs) {
    var loadRecs = function () {
      fetch(recs.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var out = $('[data-recs-result]', doc);
          if (out && out.querySelector('li')) $('[data-recs-body]', recs).innerHTML = out.innerHTML;
          else recs.hidden = true;
        })
        .catch(function () { recs.hidden = true; });
    };
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { ro.disconnect(); loadRecs(); } }, { rootMargin: '400px' });
      ro.observe(recs);
    } else loadRecs();
  }

  /* ----------------------------------------------------------------------
     Take the cushions off: scroll progress lifts the upholstered piece away.
     Left static under reduced motion; the toggle is the keyboard way in.
     ---------------------------------------------------------------------- */
  $$('[data-frame]').forEach(function (frame) {
    if (reduceMotion.matches) return;
    frame.classList.add('is-live');
    var notes = $$('.frame__note', frame);
    var toggle = $('[data-frame-toggle]', frame);
    var forced = null, forcedAt = 0, ticking = false;
    function apply(p) {
      var t = Math.min(1, Math.max(0, (p - 0.14) / 0.42));
      frame.style.setProperty('--t', t.toFixed(3));
      notes.forEach(function (n, i) { n.classList.toggle('is-on', p > 0.54 + i * 0.09); });
      if (toggle) {
        var off = t > 0.5;
        toggle.setAttribute('aria-pressed', String(off));
        toggle.textContent = toggle.getAttribute(off ? 'data-label-on' : 'data-label-off');
      }
    }
    function measure() {
      ticking = false;
      var r = frame.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var p = span > 0 ? Math.min(1, Math.max(0, -r.top / span)) : 0;
      apply(forced === null ? p : forced);
    }
    function queue() {
      if (forced !== null && Math.abs(window.scrollY - forcedAt) > 60) forced = null;
      if (!ticking) { ticking = true; requestAnimationFrame(measure); }
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    if (toggle) toggle.addEventListener('click', function () {
      forced = toggle.getAttribute('aria-pressed') === 'true' ? 0 : 1;
      forcedAt = window.scrollY;
      queue();
    });
    measure();
  });

  /* ----------------------------------------------------------------------
     Fabric library: pointing at or choosing a fabric shows it large
     ---------------------------------------------------------------------- */
  $$('[data-library]').forEach(function (lib) {
    var rows = $$('[data-lib-pick]', lib);
    var panels = $$('[data-lib-panel]', lib);
    function pick(i) {
      rows.forEach(function (r, n) { r.setAttribute('aria-pressed', String(n === i)); });
      panels.forEach(function (x, n) { x.classList.toggle('is-active', n === i); });
    }
    rows.forEach(function (r, i) {
      r.addEventListener('click', function () { pick(i); });
      r.addEventListener('mouseenter', function () { if (canHover.matches) pick(i); });
    });
  });

  /* ----------------------------------------------------------------------
     Workshop film: loads near the viewport, plays only while seen,
     stays as its poster under reduced motion.
     ---------------------------------------------------------------------- */
  var films = $$('[data-lazy-video]');
  if (films.length && !reduceMotion.matches && 'IntersectionObserver' in window) {
    var fo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (!en.isIntersecting) { v.pause(); return; }
        var src = $('source[data-src]', v);
        if (src) { src.src = src.getAttribute('data-src'); src.removeAttribute('data-src'); v.load(); }
        var playing = v.play();
        if (playing && playing.catch) playing.catch(function () {});
      });
    }, { rootMargin: '160px' });
    films.forEach(function (v) { fo.observe(v); });
  }

  /* ----------------------------------------------------------------------
     Contents list beside long guides
     ---------------------------------------------------------------------- */
  var toc = $('[data-page-toc]');
  if (toc) {
    var pageLayout = toc.closest('[data-page-layout]');
    var heads = $$('.page-body h2', pageLayout);
    if (heads.length >= 4) {
      var tocList = $('ol', toc);
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'part-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        li.appendChild(a);
        tocList.appendChild(li);
      });
      toc.hidden = false;
      pageLayout.classList.add('has-toc');
    }
  }

  /* ----------------------------------------------------------------------
     Cart drawer
     ---------------------------------------------------------------------- */
  function updateCartMeta(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    $$('[data-cart-count-text]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    return cart;
  }
  function refreshCart() {
    return fetch(cfg.routes.cart + '?section_id=cart-drawer-refresh', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = $('[data-cart-body]', doc), foot = $('[data-cart-foot]', doc);
          var liveBody = $('[data-cart-body]'), liveFoot = $('[data-cart-foot]');
          if (body && liveBody) liveBody.innerHTML = body.innerHTML;
          if (foot && liveFoot) { liveFoot.innerHTML = foot.innerHTML; liveFoot.hidden = foot.hasAttribute('hidden'); }
        }
        return fetch(cfg.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(updateCartMeta);
      });
  }
  function changeLine(key, qty) {
    return fetch(cfg.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('#cart-drawer [data-line]');
    if (!line) return;
    var key = line.getAttribute('data-key');
    var input = $('[data-line-qty]', line);
    var q = parseInt(input && input.value, 10) || 0;
    if (e.target.closest('[data-line-remove]')) { e.preventDefault(); changeLine(key, 0).then(function () { announce('Removed from your cart'); }); return; }
    if (e.target.closest('[data-line-up]')) { changeLine(key, q + 1); return; }
    if (e.target.closest('[data-line-down]')) { changeLine(key, Math.max(0, q - 1)); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('#cart-drawer [data-line-qty]');
    if (!input) return;
    changeLine(input.closest('[data-line]').getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ----------------------------------------------------------------------
     Sign-up popup (not a modal <dialog>: see snippets/popup.liquid)
     ---------------------------------------------------------------------- */
  var Popup = {
    el: $('[data-popup]'),
    open: false,
    lastFocus: null,
    KEY: 'dv_popup_until',
    FLAG: 'dv_popup_submitted',
    suppressed: function () {
      try { return Date.now() < parseInt(localStorage.getItem(Popup.KEY) || '0', 10); } catch (e) { return false; }
    },
    suppress: function () {
      try { localStorage.setItem(Popup.KEY, String(Date.now() + (cfg.popup.days || 14) * 864e5)); } catch (e) {}
    },
    busy: function () {
      return Drawer.active || Search.open || document.querySelector('.drawer.is-open') || document.querySelector('[data-nav-item].is-open');
    },
    show: function (thanks) {
      if (!Popup.el || Popup.open) return;
      if (!thanks && Popup.busy()) { setTimeout(function () { if (!Popup.suppressed()) Popup.show(false); }, 15000); return; }
      Popup.lastFocus = document.activeElement;
      Popup.el.hidden = false;
      Popup.open = true;
      if (thanks) {
        $('[data-popup-form-state]', Popup.el).hidden = true;
        $('[data-popup-thanks]', Popup.el).hidden = false;
      }
      $$('body > *').forEach(function (n) { if (n !== Popup.el && n.tagName !== 'SCRIPT' && !n.id.match(/^(a11y-status)$/)) n.setAttribute('inert', ''); });
      var first = $(FOCUSABLE, $('.popup__panel', Popup.el));
      if (first) first.focus({ preventScroll: true });
    },
    hide: function () {
      if (!Popup.open) return;
      Popup.el.hidden = true;
      Popup.open = false;
      $$('[inert]').forEach(function (n) { n.removeAttribute('inert'); });
      Popup.suppress();
      if (Popup.lastFocus && Popup.lastFocus.focus) Popup.lastFocus.focus();
    }
  };
  if (Popup.el) {
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    var mine = false;
    try { mine = sessionStorage.getItem(Popup.FLAG) === '1'; sessionStorage.removeItem(Popup.FLAG); } catch (e) {}
    if (posted && mine) {
      Popup.show(true);
    } else if (mine && $('[data-popup-error]', Popup.el)) {
      Popup.show(false); // the sign-up came back with an error: show it where it was typed
    } else if (cfg.popup.enabled && !Popup.suppressed()) {
      setTimeout(function () { if (!Popup.suppressed()) Popup.show(false); }, (cfg.popup.delay || 8) * 1000);
    }
    Popup.el.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) { e.preventDefault(); Popup.hide(); } });
    var ps = $('[data-popup-submit]', Popup.el);
    if (ps) ps.addEventListener('click', function () {
      try { sessionStorage.setItem(Popup.FLAG, '1'); } catch (e) {}
      Popup.suppress();
    });
    $$('[data-popup-wa], [data-popup-alt]', Popup.el).forEach(function (a) { a.addEventListener('click', function () { Popup.suppress(); }); });
  }

  /* ----------------------------------------------------------------------
     Swatch request: enforce the limit, keep the counter, require at least one.
     ---------------------------------------------------------------------- */
  $$('[data-swatch-form]').forEach(function (f) {
    var max = parseInt(f.getAttribute('data-max'), 10) || 4;
    var inputs = $$('[data-swatch-input]', f);
    var count = $('[data-swatch-count]', f);
    var err = $('[data-swatch-error]', f);
    function sync() {
      var n = inputs.filter(function (i) { return i.checked; }).length;
      if (count) count.textContent = n;
      inputs.forEach(function (i) { i.disabled = !i.checked && n >= max; });
      if (err && n > 0) err.hidden = true;
    }
    inputs.forEach(function (i) { i.addEventListener('change', sync); });
    f.addEventListener('submit', function (e) {
      if (!inputs.some(function (i) { return i.checked; })) {
        e.preventDefault();
        if (err) { err.hidden = false; err.scrollIntoView({ block: 'center' }); }
      }
    });
    sync();
  });

  /* ----------------------------------------------------------------------
     Global keys
     ---------------------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Popup.open) { Popup.hide(); return; }
      if (Search.open) { Search.hide(); return; }
      if (Drawer.active) { Drawer.close(); return; }
      var openItem = $('[data-nav-item].is-open');
      if (openItem) { closeNav(); var b = $('[data-nav-toggle]', openItem); if (b) b.focus(); }
    }
    Drawer.trap(e);
  });

  window.__davorelReady = true;
})();
